import * as http from '../../utils/http';
import { keysToCamelCase } from '@wix/wix-vod-shared/src/common/utils/object';

import transcodingStatuses from '../../constants/transcoding-statuses';
import events from './events/index';


const sizesDurations = {};
let premiumInfo = null;
let usage = null;


function _ensureNumber(value) {
  return _.isFinite(value) ? value : 0;
}

function _adjustUsage(usageDelta) {
  let { bytes = 0, milliseconds = 0 } = usage;

  bytes += _ensureNumber(usageDelta.bytes);
  milliseconds += _ensureNumber(usageDelta.milliseconds);

  _setUsage({ bytes, milliseconds });
}

function _adjustUsageFromFile(file, multiplier = 1) {
  if (!file) {
    return;
  }

  const { duration, size } = file;
  _adjustUsage({
    bytes: size * multiplier,
    milliseconds: duration * multiplier,
  });
}

function _increaseUsageFromFile(file) {
  _adjustUsageFromFile(file, 1);
}

function _decreaseUsageFromFile(file) {
  _adjustUsageFromFile(file, -1);
}

function _setUsage(newUsage) {
  usage = newUsage;
  return usage;
}

function _addSizeDurationToCache(itemData) {
  const { mediaFileName, mediaInfo } = itemData;

  const fileInput = _.get(mediaInfo, 'fileInput');
  if (!fileInput) {
    return;
  }

  const { duration, fileSize: size } = fileInput;

  sizesDurations[mediaFileName] = {
    duration,
    size,
  };
}

function _setPremiumInfo(newPremiumInfo) {
  premiumInfo = newPremiumInfo;
  return premiumInfo;
}


events.on(events.FILE.CAN_UPLOAD_VIDEO.SUCCESS, file => _increaseUsageFromFile(file));

_.forEach([events.ITEM.UPLOAD.SUCCESS, events.ITEM.REUPLOAD.SUCCESS], function (event) {
  events.on(event, function ({ data }) {
    _addSizeDurationToCache(data);
  });
});

_.forEach([events.ITEM.UPLOAD.FAIL, events.ITEM.REUPLOAD.FAIL], function (event) {
  events.on(event, function (response, itemData) {
    if (_.get(response, 'error.data.errorCode') === -1810) {
      // don't react on quota exceeded errors
      return;
    }

    _decreaseUsageFromFile(itemData.file);
  });
});

events.on(events.TRANSCODING.UPDATE, function ({ id, transcodingStatus }) {
  const file = sizesDurations[id];

  if (transcodingStatus === transcodingStatuses.FAILED) {
    _decreaseUsageFromFile(file);
  }
});

events.on(events.ITEMS.LIST.SUCCESS, function ({ data }) {
  _.forEach(data, _addSizeDurationToCache);
});


export default function (settings, adapterMethods) {

  function getPremiumInfo(trigger, force = false) {
    if (premiumInfo && !force) {
      return Promise.resolve(premiumInfo);
    }

    return http.get(`${settings.apiUrl}/billing/info`)
      .then(_.property('data'))
      .then(keysToCamelCase)
      .then(_setPremiumInfo);
  }

  function getUsage(trigger, force = false) {
    return getUsageFromBackend(trigger)
      .then(confirmedUsage => {
        if (!usage || force) {
          _setUsage(confirmedUsage);
        }

        return {
          confirmed: confirmedUsage,
          estimated: usage,
        };
      });
  }

  function getUsageFromBackend() {
    return http.get(`${settings.apiUrl}/catalog/users/usage`)
      .then(_.property('data.usage'))
      .then(keysToCamelCase)
      .then(function ({ totalVideoBytes, totalVideoDuration }) {
        return {
          bytes: totalVideoBytes || 0,
          milliseconds: totalVideoDuration || 0,
        };
      });
  }


  events.on(events.ITEMS.REMOVE.SUCCESS, function () {
    setTimeout(() => adapterMethods.premium.getUsage(_.noop, true), 1000);
  });


  return {
    getPremiumInfo,
    getUsage,
  };
}



// WEBPACK FOOTER //
// ./src/transport/adapters/vod/premium.js